export const verifyScreenVerbiage = {
    NO_PHONE_NUM_VERIFIED: "You do not currently have a mobile number specified in your GroupAccess profile. Update your contact information and you may add a mobile number for future account verification via text message.",
    RECOMMEND_2FA_ALWAYS_ON: "For added security, we recommend enabling two-step verification to verify your identity each time, on any device. In addition, we recommend you confirm your contact information is up to date",
    UPDATE_PHONE_CONTACT_INFO: "Update My Phone Number",
    UPDATE_EMAIL_CONTACT_INFO: "Update My Email Address",
    UPDATE_LATER: "I'll do this later. Take me home.",
    UPDATE_PHONE_LINK_PARAM: "&targetApplication=change-phone-number",
    UPDATE_EMAIL_LINK_PARAM: "&targetApplication=change-email",
}

